"use client"
import { useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";

interface TabItem {
  id: string;
  title: string;
  heading: string;
  description1: string;
  subhad?: string;
  details?: React.ReactNode;
  descriptionlist?: React.ReactNode;
}

interface ContentTabsProps {
  tabs: TabItem[];
  title:string;
}

const ContentTabs : React.FC<ContentTabsProps> = ({ tabs, title }) => {
  const [activeTab, setActiveTab] = useState<string>(tabs[0].id);

  return (
    <div className="container">
      <div className="text-center mb-5 mt-5">
        <h4 className="fw-bold display-5 text-center textHad">
          {title}
        </h4>
      </div>
      <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k!)}>
        <Row>
          <Col sm={4}>
            <Nav variant="pills" className="flex-column">
              {tabs.map(({ id, title }) => (
                <Nav.Item key={id}>
                  <Nav.Link eventKey={id}>{title}</Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
          <Col sm={8}>
            <Tab.Content>
              {tabs.map(({ id, heading, subhad, description1, descriptionlist, details }) => (
                <Tab.Pane eventKey={id} key={id} className="text-start">
                  <h5 className="textOrange fw-bold fs-3 mt-2">{heading}</h5>
                  <p className="fs-4 textPara fw-bold">{subhad}</p>
                  <p className="fs-5 textPara">{description1}</p>
                  <div className="fs-5 textPara">{descriptionlist}</div>
                  <div className="bg-light fs-5 textPara  p-3">{details}</div>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default ContentTabs;
